/* eslint-disable import/prefer-default-export */
export const isNotNullOrUndefined = (answer) => {
  return (answer !== null && answer !== undefined);
};
